// extracted by mini-css-extract-plugin
module.exports = {"link":"index__link___1nEi6"};